export default "__VITE_ASSET__DaZi7t0D__"